import { ZERO } from 'modules/common/const';

import { IModalSuccessState, IModalUnstakeSuccessState } from './types';

export enum LiquidStakingTab {
  Stake = 'stake',
  Unstake = 'unstake',
  Withdrawal = 'withdrawal',
}

export enum UnstakeType {
  Unstake = 'unstake',
  FlashUnstake = 'flash-unstake',
}

export const EMPTY_MODAL_SUCCESS_STATE: IModalSuccessState = {
  inAmount: ZERO,
  outAmount: ZERO,
  txHash: undefined,
};

export const DEFAULT_UNSTAKE_TYPE = UnstakeType.Unstake;

export const EMPTY_MODAL_UNSTAKE_SUCCESS_STATE: IModalUnstakeSuccessState = {
  ...EMPTY_MODAL_SUCCESS_STATE,
  type: DEFAULT_UNSTAKE_TYPE,
};
